import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { objectToFormData, capitalize, hasAccess } from "../../utils";
import {
  cards,
  corporateBudget,
  Topup,
  topup,
} from "../../actions/cards/cards";
// import { expenses } from "../../actions/expenses/expenses";
import { Modal, Typography, Button, Input, Row, Col, message } from "antd";
import PageHeader from "../PageHeader";
import Table from "../Common/Table/Table";
import { FileTextOutlined } from "@ant-design/icons";
import uparrow from "../../assets/icons/arrow-up.svg";
import BaseCurrency from "../Common/BaseCurrency";
import endpoint from "../../config/Axios";
import { apis } from "../../config/APIs";

const { Title } = Typography;

const Transfers = () => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [recordData, setRecordData] = React.useState({});
  const [modalData, setModalData] = React.useState([]);
  const [topupValue, setTopupValue] = React.useState({});
  const [topupType, setTopupType] = React.useState("");
  const dispatch = useDispatch();
  const cardsResponse = useSelector((state) => state.cards.cards || {});
  const topupResponse = useSelector((state) => state.cards.topup || {});
  const {
    data: { response: { cards: cardsList = [] } = {}, total_records } = {},
  } = cardsResponse;

  const columns = [
    {
      title: "CRN",
      dataIndex: "card_reference_no",
      key: "card_reference_no",
      render: (text, record) => (
        <div className={`render_common_style status_${record?.status}`}>
          {text}
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "title",
      key: "title",
      render: (text, record) => <div>{record.employee_details?.name}</div>,
    },
    // {
    //   title: "Total Loaded",
    //   dataIndex: "title",
    //   key: "title",
    //   render: (text) => <div>Rs. 1,15,000</div>,
    // },
    // {
    //   title: "Available Balance",
    //   dataIndex: "cardBalance",
    //   key: "cardBalance",
    //   render: (text, record) => <div>{record?.data?.cardBalance}</div>,
    // },
    // {
    //   title: "Available Limit",
    //   dataIndex: "title",
    //   key: "title",
    //   // render: (text) => <div>Rs. 85,000</div>,
    // },
    {
      title: "Email",
      dataIndex: "title",
      key: "title",
      render: (text, record) => <div>{record.employee_details.email}</div>,
    },
    {
      title: "Phone",
      dataIndex: "title",
      key: "title",
      render: (text, record) => <div>{record.employee_details.mobile}</div>,
    },
    // {
    //   title: "Topup Wallets",
    //   dataIndex: "title",
    //   key: "title",
    //   render: (text, record) => (
    //     <div>{record.wallets?.map((item) => item.wallet_name).join(", ")}</div>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <div className={`status ${text}`}>{text}</div>,
    },
    {
      title: <div className="table-placeholder">Load Money</div>,
      dataIndex: "title",
      key: "title",
      render: (text) => (
        <button
          className="arrowBackground flex-center"
          onClick={() => setIsModalVisible(true)}
          disabled={!hasAccess("transfers", "write")}
        >
          <img src={uparrow} alt="" width={18} />
        </button>
      ),
    },
    // {
    //   title: <div className="table-placeholder">Withdraw Money</div>,
    //   dataIndex: "title",
    //   key: "title",
    //   render: (text) => <div className="arrowBackground" onClick={() => setIsModalVisible(true)}><ArrowDownOutlined /></div>,
    // },
  ];

  const modalColumns = [
    {
      title: "Wallet Type",
      dataIndex: "wallet_name",
      key: "wallet_name",
      width: 200,
      render: (text) => (
        <div>
          <FileTextOutlined /> &nbsp;{capitalize(text)}
        </div>
      ),
    },
    // {
    //   title: "Remaining Limit",
    //   dataIndex: "remaining",
    //   key: "remaining",
    //   // render: (text) => <div>INR 11,200.00</div>,
    // },
    {
      title: "Available Balance",
      dataIndex: "balance",
      key: "balance",
      render: (text) => (
        <div>
          <BaseCurrency /> {text}
        </div>
      ),
    },
    // {
    //   title: "Amount",
    //   dataIndex: "title",
    //   key: "title",
    //   render: (text, record) => (
    //     <Input
    //       style={{ width: "100px" }}
    //       key={record.id}
    //       value={topupValue[record.wallet_identifier] || ""}
    //       onChange={(e) => ontopupChange(e, record.wallet_identifier)}
    //     />
    //   ),
    // },
    {
      title: "Amount",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <Input
          style={{ width: "100px" }}
          key={record.id}
          value={topupValue[record.wallet_identifier] || ""}
          onChange={(e) => onTopupChange(e, record.wallet_identifier)}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <button
          className="arrowBackground flex-center"
          disabled={!(topupType === record.wallet_identifier)}
          onClick={() => handleTopupSubmit(record.wallet_identifier)}
        >
          <img src={uparrow} alt="" width={18} />
        </button>
      ),
    },
  ];

  React.useEffect(() => {
    dispatch(cards({ status: "A", source: "admin" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: {
        message: res_message1 = "",
        status = "",
        errors: { message: res_message = "" } = {},
      } = {},
    } = topupResponse;
    if (status) {
      dispatch(corporateBudget());
      endpoint
        .get(
          apis.cardsDetails,
          {
            params: { card_id: recordData.id },
          },
          { skipSuccessMessage: true },
        )
        .then(() => {
          dispatch(
            cards({
              status: "A",
              source: "admin",
            }),
          );
        });
      setTopupValue("");
      setTopupType("");
      dispatch({
        type: Topup.RESET,
      });
      handleCancel();
    } else {
      if (status === false) {
        dispatch({
          type: Topup.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topupResponse]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setTopupValue({});
  };

  const handleRowClick = (evt, record) => {
    evt.preventDefault();
    if (record) {
      setModalData([...modalData, record]);
      setRecordData(record);
    }
  };

  const ontopupChange = (e, type) => {
    let value = e.target.value;

    if (value === "" || !Number.isNaN(Number(value))) {
      console.log("@123=====", value);
      setTopupType(type);
      setTopupValue({ [type]: value });
    }
  };

  const handleTopupSubmit = (val) => {
    const payload = {};
    payload["card_id"] = recordData.id;
    payload["amount"] = topupValue[topupType];
    payload["wallet_identifier"] = topupType;

    dispatch(topup(objectToFormData({ ...payload })));
  };

  const renderQuickLoad = () => {
    return (
      <>
        <div className="quickLoadHead">
          <Row>
            <Col span={7}>
              <p>Card Holder Name</p>
              <p>Card Holder Email</p>
              <p>Card Kit Number</p>
            </Col>
            <Col span={16}>
              <span>{recordData?.employee_details?.name}</span>
              <br />
              <span title={recordData?.employee_details?.email}>
                {recordData?.employee_details?.email}
              </span>
              <br />
              <span>{recordData?.card_reference_no}</span>
            </Col>
          </Row>
        </div>
        <br />

        <Table rowKey="id" columns={modalColumns} data={recordData?.wallets} />
        <div>
          <Button
            key="2"
            className="cancelButton  mt1"
            onClick={() => handleCancel()}
          >
            Cancel
          </Button>
        </div>
      </>
    );
  };

  // Function to handle the onChange event and validate the amount
  const onTopupChange = (e, walletIdentifier) => {
    const value = e.target.value;
    const numericValue = parseFloat(value);
    console.log("value values", { value, numericValue });

    // Allow empty input for clearing the field
    if (value === "") {
      ontopupChange(e, walletIdentifier);
      topupValue[walletIdentifier] = value; // Clear the value
      return;
    }

    // Validation check for numeric and range
    if (numericValue >= 0 && numericValue <= 90000) {
      ontopupChange(e, walletIdentifier);
      topupValue[walletIdentifier] = value; // Update value if valid
    } else {
      message.error(
        <span className="messageText">
          Amount must be a positive value less than 90,000
        </span>,
      );
    }
  };

  return (
    <>
      <Modal
        title={
          <Title level={4}>
            Quick Load &nbsp;
            <span className="text-small">Enter details and submit</span>
          </Title>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className="right-alinged-modal"
      >
        {renderQuickLoad()}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Transfers`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            "Quick Transfers": "/transfers/quick-transfers/",
          }}
        />
      </div>
      <Table
        rowKey="id"
        handleRowClick={handleRowClick}
        placeholder={"Search By CRN, Name"}
        columns={columns}
        data={cardsList}
        handleSearch={(value) => {
          dispatch(
            cards({
              status: "A",
              search: value,
              source: "admin",
            }),
          );
        }}
        isTopFilter={true}
        filter={true}
        isMore={true}
        scroll={{ x: 0 }}
        className="tableStyled admin cards"
        pagination={{
          total: total_records || 0,
          onChange: (pagee) => {
            dispatch(
              cards({
                page: pagee,
                status: "A",
                source: "admin",
              }),
            );
          },
        }}
      />
    </>
  );
};

export default Transfers;
